import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  modalInsideStack: {
    width: 1400,
    height: 800,
  },
  documentTypeDropdown: {
    width: 250,
  },
  row: {
    minWidth: '100% !important',
  },
  messageBarStyle: { width: 330 },
  stickyInsideStack: {
    alignItems: 'self-start',
    padding: 25,
  },
  stack: {
    padding: 25,
  },
  disabledText: {
    color: `${theme.palette.neutralTertiary}${theme.isInverted ? '55' : ''}`,
  },
  paddingL25: {
    paddingLeft: 25,
  },
  columnHeight: {
    height: 25,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },

  onrenderColumnStack: {
    height: 25,
  },
}));
